import barba from "@barba/core";
barba.init({
  prevent: ({ el }) => {
    // Jeśli element znajduje się wewnątrz #wpadminbar lub NIE jest częścią ul.menu-menu a oraz ul.menu a, zignoruj przejście Barba.
    return (
      el.closest("#wpadminbar") ||
      !(el.closest("ul.menu-menu a") || el.closest("ul.menu a"))
    );
  },

  transitions: [
    {
      name: "default-transition",

      once({ current, next, trigger }) {
        // Kod dla pierwszego ładowania strony
        next.container.classList.add("active-page");
      },

      leave({ current, next, trigger }) {
        let slider = document.querySelector("img-comparison-slider");
        if (slider) {
          slider.remove();
        }
        return new Promise((resolve) => {
          current.container.classList.remove("active-page");
          setTimeout(() => {
            resolve();
          }, 500); // opóźnienie musi odpowiadać czasowi trwania animacji w CSS
        });
      },

      enter({ current, next, trigger }) {
        let newClass = next.container.dataset.bodyClass;
        if (newClass) {
          document.body.className = newClass;
        }

        const aosElements = next.container.querySelectorAll("[data-aos]");
        aosElements.forEach((el) => {
          el.classList.remove("aos-init", "aos-animate");
        });

        // Odświeżanie wszystkich skryptów w <body>
        const scripts = Array.from(document.body.querySelectorAll("script"));
        scripts.forEach((oldScript) => {
          const newScript = document.createElement("script");

          Array.from(oldScript.attributes).forEach((attr) => {
            newScript.setAttribute(attr.name, attr.value);
          });

          if (oldScript.innerHTML) {
            newScript.innerHTML = oldScript.innerHTML;
          }

          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
        window.scrollTo(0, 0);
        next.container.classList.add("active-page");
      },
    },
  ],
});
